export default {
  data() {
    return {
      isLoad: false,
      isShowDom: false,
    }
  },
  mounted() {
    if (window.innerWidth > 768) {
      this.isLoad = true;
    }

    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll: function() {
      if (!this.isShowDom) {
        if (window.scrollY >= 800) {
          this.isShowDom = true;
          (function u(){var u=document.createElement("script");u.type="text/javascript",u.async=true,u.src='//api.u-komi.com/' + process.env.MIX_KOMI_KEY + '/widget.js';var k=document.getElementsByTagName("script")[0];k.parentNode.insertBefore(u,k)})();
        }
      }
    }
  }
}
